/** Available code editor color themes. */
export enum CodeEditorTheme {
  /** GitHub Light - Clean light theme (default). */
  githubLight = 'github-light',
  /** Solarized Light - Warm light theme, easy on the eyes. */
  solarizedLight = 'solarized-light',
  /** Dracula - Popular dark theme with purple accents. */
  dracula = 'dracula',
  /** Oceanic Next - Modern dark theme with ocean colors. */
  oceanicNext = 'oceanic-next'
}
